import { RolesEnum } from 'core/models';
import { RoleName } from 'core/models/roleModel';
import { config } from 'core/config';

export type Rules = {
  [key in RoleName]: string[];
};

const {
  baseUrl,
  profile,
  forbidden,
  clinics,
  changePassword,
  restorePassword,
  verifyPassword,
  addPath,
  pmManagement,
  adminManagement,
  techManagement,
  physicianManagement,
  devices,
  sensors,
  monitoringProtocols,
  dashboard,
  dashboardEvent,
  dashboardRpmAlert,
  ecgDataChunks,
  pec,
  process,
  reports,
  reportArchive,
  generateReport,
  reportsPdf,
  settings,
  analysisSetting,
  otherSetting,
  groupManagement,
  historyView,
  ecgRecord,
  patients,
  sites,
  studies,
  studiesManagement,
  researchersManagement,
  clinicalTrialCoordinatorManagement,
  userManagement,
  superAdminManagement,
  emailTemplate,
  smsTemplate,
  patientTemplate,
  ssoSetting,
  dataAnalytics,
  tenant,
  tenantDevice,
  management,

  rpmRT,
  addRpmPatient,
  supersetContainer,
  supersetCalendar,

  orderManagement,
  downloads,
} = config.paths;

export const rules = (): Rules => {
  const defaultsRules = [
    baseUrl,
    profile,
    forbidden,
    profile,
    `${profile}${changePassword}`,
    restorePassword,
    `${restorePassword}/:token`,
    `${verifyPassword}/:token`,
    pec,
    downloads,
  ];

  const supersetRules = [
    `${dataAnalytics}`,
    supersetContainer,
    supersetCalendar,
  ];

  const tenantRules = [
    sites,
    emailTemplate,
    smsTemplate,
    analysisSetting,
    otherSetting,
    patientTemplate,
    ssoSetting,
  ];

  return {
    VivaLNKAdmin: [
      ...defaultsRules,
      management,
      userManagement,
      `${userManagement}/:id`,
      `${userManagement}${addPath}`,
      clinics,
      `${clinics}/:id`,
      `${clinics}${addPath}`,
      // ecgDataChunks,
      `${tenantDevice}`,
    ],
    SuperAdmin: [...defaultsRules, management, userManagement, clinics],
    TenantAdmin: [
      ...defaultsRules,
      ...supersetRules,
      devices,
      sensors,
      management,
      patients,
      rpmRT,
      dashboard,
      dashboardEvent,
      dashboardRpmAlert,
      userManagement,
      `${userManagement}${pmManagement}`,
      `${userManagement}${pmManagement}${addPath}`,
      `${userManagement}${researchersManagement}`,
      `${userManagement}${researchersManagement}${addPath}`,
      `${userManagement}${adminManagement}`,
      `${userManagement}${techManagement}`,
      `${userManagement}${physicianManagement}`,
      `${userManagement}${clinicalTrialCoordinatorManagement}`,
      monitoringProtocols,
      `${settings}`,
      ...tenantRules,
      `${groupManagement}`,
      historyView,
      studiesManagement,
      reports,
      generateReport,
      reportsPdf,
      process,
      reportArchive,
    ],
    ProgramManager: [
      ...defaultsRules,

      // devices,
      // sensors,
      // patients,
      rpmRT,
      dashboard,
      // dashboardEvent,
      // dashboardRpmAlert,
      management,
      userManagement,
      monitoringProtocols,

      groupManagement,

      historyView,
      studiesManagement,
      rpmRT,
      `${settings}`,
      ...tenantRules,
      // reports,
      // generateReport,
      // reportsPdf,
      // process,
      // reportArchive,
    ],
    SiteAdmin: [
      ...defaultsRules,
      devices,
      sensors,
      patients,
      rpmRT,
      dashboard,
      dashboardEvent,
      dashboardRpmAlert,
      management,
      userManagement,
      monitoringProtocols,
      `${groupManagement}`,
      historyView,
      studiesManagement,
      rpmRT,
      reports,
      generateReport,
      reportsPdf,
      process,
      reportArchive,
    ],
    Admin: [
      ...defaultsRules,
      devices,
      sensors,
      management,
      patients,
      rpmRT,
      dashboard,
      dashboardEvent,
      dashboardRpmAlert,
      userManagement,
      monitoringProtocols,
      `${settings}`,
      `${groupManagement}`,
      historyView,
      studiesManagement,
      rpmRT,
      reports,
      generateReport,
      reportsPdf,
      process,
      reportArchive,
    ],
    Technician: [
      ...defaultsRules,
      dashboard,
      dashboardEvent,
      dashboardRpmAlert,
      patients,
      `${patients}/:id${dashboard}`,
      `${patients}/:id${dashboard}/:studyId`,
      `${patients}/:id${dashboard}/:studyId/:eventId/:tabId`,
      `${patients}${ecgRecord}`,
      reports,
      generateReport,
      reportsPdf,
      process,
      rpmRT,
      addRpmPatient,
    ],
    Physician: [
      ...defaultsRules,
      dashboard,
      dashboardEvent,
      dashboardRpmAlert,
      patients,
      `${patients}/:id${dashboard}`,
      `${patients}/:id${dashboard}/:studyId`,
      `${patients}/:id${dashboard}/:studyId/:eventId/:tabId`,
      `${patients}${ecgRecord}`,
      reports,
      generateReport,
      reportsPdf,
      rpmRT,
      process,
    ],
    Researcher: [
      ...defaultsRules,
      dashboard,
      patients,
      `${patients}${ecgRecord}`,
      reports,
      generateReport,
      reportsPdf,
      rpmRT,
      process,
    ],
    ClinicalTrialCoordinator: [...defaultsRules, orderManagement],
    EnrollmentCoordinator: [
      ...defaultsRules,
      dashboard,
      management,
      patients,
      devices,
      sensors,
    ],
    Analyst: [...supersetRules],
  };
};

export const userPathByRole = (userRole?: RolesEnum): string => {
  switch (userRole) {
    case RolesEnum.ProgramManager:
      return pmManagement;
    case RolesEnum.Admin:
      return adminManagement;
    case RolesEnum.Technician:
      return techManagement;
    case RolesEnum.Physician:
      return physicianManagement;
    case RolesEnum.Researcher:
      return researchersManagement;
    case RolesEnum.ClinicalTrialCoordinator:
      return clinicalTrialCoordinatorManagement;
    default:
      return '';
  }
};
